import React from 'react'
import {
    MdEmail, MdPhone
} from 'react-icons/md'

export default function ContactIcons() {
    return (
        <>
                    <MdEmail size={45} className="ani"></MdEmail>
                    <MdPhone size={45} className="ani"></MdPhone>
          </>
    );
}
